const INTEGRATIONS = {
    NAME: 'integrations',
    PATH: 'map-:mapId/integrations'
};

const WEB_INTEGRATION = {
    CATALOGUE: {
        ROOT: {
            NAME: 'web.integration.catalogue',
            PATH: 'web'
        },
        START: {
            NAME: 'web.integration.catalogue.start',
            PATH: 'start'
        },
        SETTINGS: {
            NAME: 'web.integration.catalogue.settings',
            path: 'path-settings'
        },
        PATH: {
            NAME: 'web.integration.catalogue.path',
            PATH: 'path'
        },
        LIST: {
            NAME: 'web.integration.catalogue.list',
            PATH: 'list'
        }
    },
    STORE: {
        ROOT: {
            NAME: 'web.integration.store',
            PATH: 'web'
        },
        INFO: {
            NAME: 'web.integration.store.info',
            PATH: 'info'
        },
        SETTINGS: {
            NAME: 'web.integration.store.settings',
            path: 'path-settings'
        },
        PATH: {
            NAME: 'web.integration.store.path',
            PATH: 'path'
        },
    }
};

export {
    INTEGRATIONS,
    WEB_INTEGRATION
};